import { accountBadgeEntityName } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { PageError } from '@juvare/common-web-ui/PageError';
import { getErrorMessage, signalPdfError, signalPdfReady } from '@juvare/common-web-ui/utils';
import { useAttachmentDataUrl } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
export const BadgePrintPreview = ({ imageAttachmentKey }) => {
    const { t } = useBadgingTranslation();
    const { accountBadgeId } = useParams();
    const { data: imageDataUrl, isLoading, error } = useAttachmentDataUrl(accountBadgeEntityName, accountBadgeId, imageAttachmentKey);
    React.useEffect(() => {
        if (accountBadgeId && imageDataUrl) {
            signalPdfReady();
        }
        else if (error) {
            signalPdfError(getErrorMessage(error));
        }
    }, [accountBadgeId, imageDataUrl, error]);
    if (error) {
        return React.createElement(PageError, { type: 'not-found', error: error });
    }
    if (isLoading) {
        return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' } },
            React.createElement(CircularProgress, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("style", null, `
                    @page {
                        size: 2.125in 3.375in;
                    }
                `),
        React.createElement(Box, { component: 'img', sx: { maxWidth: '100%', display: 'block', objectFit: 'fill' }, src: imageDataUrl, alt: t('common.accountBadge') })));
};
